import { apiClient } from "../../../shared/api/AllApi";

const FALLBACK_TYPES = [
  { code: "rent", name: "کرێی عەمار", sort_order: 1, is_active: true },
  { code: "transport", name: "حمالیە", sort_order: 2, is_active: true },
  { code: "moving", name: "گواستنەوە", sort_order: 3, is_active: true },
  { code: "watching", name: "پاسەوانی", sort_order: 4, is_active: true },
  { code: "other", name: "خەرجی دیکە", sort_order: 5, is_active: true },
];

let cache = null;
let cacheAt = 0;
const TTL_MS = 60_000;

export async function fetchExpenseTypes({ all = false, force = false } = {}) {
  const now = Date.now();
  if (!force && !all && cache && now - cacheAt < TTL_MS) return cache;
  try {
    const res = await apiClient.get("/farmer-expense-types", { params: all ? { all: 1 } : {} });
    const rows = Array.isArray(res.data?.types) ? res.data.types : [];
    if (!all) {
      cache = rows;
      cacheAt = now;
    }
    return rows.length ? rows : FALLBACK_TYPES;
  } catch {
    return FALLBACK_TYPES;
  }
}

export function invalidateExpenseTypesCache() {
  cache = null;
  cacheAt = 0;
}

/** Map code → display name */
export function expenseTypeLabelMap(types) {
  const map = {};
  (types || []).forEach((t) => { map[t.code] = t.name; });
  return map;
}

/**
 * Group expenses by type for print/summary rows.
 * Always returns every configured type (amount 0 if nothing added),
 * then any unknown codes that have amounts (legacy data).
 */
export function groupExpensesByType(expenses, types = []) {
  const typeList = (types && types.length) ? types : FALLBACK_TYPES;
  const labels = expenseTypeLabelMap(typeList);

  const sums = {};
  typeList.forEach((t) => { sums[t.code] = 0; });

  (expenses || []).forEach((e) => {
    if (e.cancelled_at) return;
    const code = e.type || "other";
    sums[code] = (sums[code] || 0) + (parseFloat(e.amount) || 0);
  });

  const known = typeList.map((t) => ({
    code: t.code,
    label: labels[t.code] || t.name || t.code,
    amount: sums[t.code] || 0,
  }));

  const extras = Object.entries(sums)
    .filter(([code]) => !(code in labels))
    .filter(([, amount]) => amount > 0)
    .map(([code, amount]) => ({
      code,
      label: code,
      amount,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  return [...known, ...extras];
}
